type VisibilityCallback = (visible: boolean) => void;

const callbacks = new Set<VisibilityCallback>();

/**
 * Handles tab background/foreground transitions.
 * Critical for:
 * - Timer accuracy (setInterval throttled in background)
 * - WebSocket reconnection after tab sleep
 */
export function onVisibilityChange(cb: VisibilityCallback): () => void {
  callbacks.add(cb);
  return () => callbacks.delete(cb);
}

export function initVisibilityManager(): void {
  document.addEventListener('visibilitychange', () => {
    const visible = document.visibilityState === 'visible';
    callbacks.forEach(cb => cb(visible));
  });
}
